import HeaderContent from "component/layout/HeaderContent";
import React from "react";
import { useNavigate } from "react-router-dom";
import TopHeader from "./component/TopHeader";
import AdviceTimelinePage from "./AdviceTimelinePage";
import EvalHeader from "./component/EvalHeader";
import { useLocation } from "react-router-dom";
import { EmployeeModel } from "domains/models/EmployeeModel";
import { toJS } from "mobx";
import AdviceTimelineGraphPage from "pages/AdviceTimelineGraphPage/AdviceTimelineGraphPage";
import AdviceTimelinePageStore from "./store/AdviceTimelinePageStore";
import { observer, useLocalObservable } from "mobx-react";

function AdviceTimelinePageRouter() {
  const pageStore = useLocalObservable(() => new AdviceTimelinePageStore());


  return (
    <HeaderContent>
      <TopHeader isBackIcon isChangeIcon pageStore={pageStore} />

      {pageStore.isChecked ? (
        <AdviceTimelineGraphPage pageStore={pageStore} />
      ) : (
        <AdviceTimelinePage pageStore={pageStore} />

      )}
    </HeaderContent>
  );
}

export default observer(AdviceTimelinePageRouter);
